import "./index.css";
import ServiceTree from "./ServiceTree";
const MainMB = ({ programListing }) => {
  return (
    <>
      <ServiceTree programListing={programListing} />
    </>
  );
};

export default MainMB;
